import type { Sentiment } from '@hotjar/webapp/domains/activation/feedback-widgets/types';

export function getSentimentAvg(sentiment: Sentiment, total: number): number {
  if (total === 0) {
    return 0;
  }

  const avg =
    (1 * sentiment[0] + 2 * sentiment[1] + 3 * sentiment[2] + 4 * sentiment[3] + 5 * sentiment[4]) /
    total;

  return Math.round(avg * 10) / 10;
}
